
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { Account } from "@/types/strategy-types";

export const useAccountsData = (providerId?: string | null) => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const loadAccounts = async () => {
    try {
      setLoading(true);
      let query = supabase.from('account').select('*');
      
      // Filter by provider if needed
      if (providerId) {
        const { data: leadAccounts } = await supabase
          .from('lead_account')
          .select('id')
          .eq('strategy_provider_id', providerId);
        
        if (leadAccounts && leadAccounts.length > 0) {
          const leadAccountIds = leadAccounts.map(la => la.id);
          query = query.in('lead_account_id', leadAccountIds);
        }
      }
      
      const { data, error } = await query;
      
      if (error) throw error;
      setAccounts(data || []);
    } catch (error) {
      console.error('Error loading accounts:', error);
      toast({
        title: "Error",
        description: "Failed to load accounts",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    accounts,
    loading,
    loadAccounts
  };
};
